export default [
  {
    path: "/ai-invoice-accounting-value-types",
    name: "ai-invoice-accounting-value-types",
    component: () =>
      import(
        "@/modules/ai-Invoice-accounting-value-types/AiInvoiceAccountingValueType.vue"
      ),
    children: [
      {
        path: "list",
        name: "list-ai-invoice-accounting-value-types",
        component: () =>
          import(
            "@/modules/ai-Invoice-accounting-value-types/pages/AiInvoiceAccountingValueTypeList.vue"
          ),
        meta: { permissions: ["ai-invoice-accounting-value-types-show"] }
      },
      {
        path: "add",
        name: "add-ai-invoice-accounting-value-types",
        component: () =>
          import(
            "@/modules/ai-Invoice-accounting-value-types/pages/AiInvoiceAccountingValueTypeAdd.vue"
          ),
        meta: { permissions: ["ai-invoice-accounting-value-types-create"] }
      },
      {
        path: "edit/:id",
        name: "edit-ai-invoice-accounting-value-types",
        component: () =>
          import(
            "@/modules/ai-Invoice-accounting-value-types/pages/AiInvoiceAccountingValueTypeEdit.vue"
          ),
        meta: { permissions: ["ai-invoice-accounting-value-types-update"] }
      }
    ]
  }
];
